import React, { useEffect } from 'react';
import { safeRedirect } from '../../utils/navigationUtils';

const ProtectedRoute = ({ children, role, roles }) => {
  const userData = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  
  let userRole = '';
  if (userData) {
    try {
      const user = JSON.parse(userData);
      userRole = user.role;
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
  }

  // Handle all redirections in a single useEffect
  useEffect(() => {
    // Check if not authenticated
    if (!token) {
      safeRedirect('/login');
      return;
    }

    // Check if roles array is provided
    if (roles) {
      if (!roles.map(r => r.toLowerCase()).includes(userRole?.toLowerCase())) {
        // Redirect based on user role
        handleRoleBasedRedirect(userRole);
        return;
      }
    }
    // Check single role if provided
    else if (role && userRole?.toLowerCase() !== role.toLowerCase()) {
      // Redirect based on user role
      handleRoleBasedRedirect(userRole);
      return;
    }
  }, [token, userRole, role, roles]);

  // Helper function for role-based redirects
  const handleRoleBasedRedirect = (role) => {
    switch (role?.toLowerCase()) {
      case 'admin':
        safeRedirect('/admin-dashboard');
        break;
      case 'owner':
        safeRedirect('/owner-dashboard');
        break;
      case 'teacher':
        safeRedirect('/dashboard');
        break;
      case 'student':
        safeRedirect('/dashboard');
        break;
      default:
        safeRedirect('/login');
        break;
    }
  };

  // Determine if we should render children
  const shouldRender = token && (
    (roles && roles.map(r => r.toLowerCase()).includes(userRole?.toLowerCase())) ||
    (role && userRole?.toLowerCase() === role.toLowerCase())
  );

  return shouldRender ? children : null;
};

export default ProtectedRoute;
